import { defineStore } from 'pinia'
import { siteService } from '@/services/siteService'

export const useSiteStore = defineStore('site', {
  state: () => ({
    sites: [],
    filter: {},
  }),

  actions: {
    async getSitesList() {
      try {
        const response = await siteService.getSitesList(this.filter);
        this.sites = response.data.data;
      } catch (error) {
        console.log(error);
        return;
      }
    },
  }
});